<script>
import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: ['chartdata', 'options'],
  mounted() {
    this.renderChart(this.chartdata, this.options)
  },
  watch: {
    chartdata(newVal) {
      this.renderChart(newVal, this.options)
    },
  },
}
</script>
